import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  isDark: boolean
  toggle: () => void
  setDark: (isDark: boolean) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDark: true,
      toggle: () =>
        set((state) => {
          const newIsDark = !state.isDark
          // Update both the class and color-scheme
          if (newIsDark) {
            document.documentElement.classList.add('dark')
            document.documentElement.style.colorScheme = 'dark'
          } else {
            document.documentElement.classList.remove('dark')
            document.documentElement.style.colorScheme = 'light'
          }
          return { isDark: newIsDark }
        }),
      setDark: (isDark) =>
        set(() => {
          // Update both the class and color-scheme
          if (isDark) {
            document.documentElement.classList.add('dark')
            document.documentElement.style.colorScheme = 'dark'
          } else {
            document.documentElement.classList.remove('dark')
            document.documentElement.style.colorScheme = 'light'
          }
          return { isDark }
        }),
    }),
    {
      name: 'theme-storage',
      // On rehydration from localStorage, apply the theme immediately
      onRehydrateStorage: () => (state) => {
        if (state) {
          if (state.isDark) {
            document.documentElement.classList.add('dark')
            document.documentElement.style.colorScheme = 'dark'
          } else {
            document.documentElement.classList.remove('dark')
            document.documentElement.style.colorScheme = 'light'
          }
        }
      },
    }
  )
)

// Initialize theme on first load (before React hydration)
const storedTheme = localStorage.getItem('theme-storage')
if (storedTheme) {
  try {
    const { state } = JSON.parse(storedTheme)
    if (state.isDark) {
      document.documentElement.classList.add('dark')
      document.documentElement.style.colorScheme = 'dark'
    } else {
      document.documentElement.classList.remove('dark')
      document.documentElement.style.colorScheme = 'light'
    }
  } catch (e) {
    // Default to dark mode if parsing fails
    document.documentElement.classList.add('dark')
    document.documentElement.style.colorScheme = 'dark'
  }
} else {
  // Default to dark mode
  document.documentElement.classList.add('dark')
  document.documentElement.style.colorScheme = 'dark'
}
